import React, { useEffect, useState } from "react";
import Page, { Grid, GridColumn } from "@atlaskit/page";
import MainNav from "./MainNav";
import { BrowserRouter as Router, Navigate, Routes, Route } from "react-router-dom";
import IntegrationsPage from "../integrations/IntegrationsPage";
import AuthPage from "../auth/AuthPage";
import ExecutionLogPage from "../integrations/executionlog/ExecutionLogPage";
import ErrorBoundary from "../error/ErrorBoundary";
import Loading from "../common/components/Loading";
import LandingPage from "./LandingPage";
import JsonPathPage from "./tools/JsonPathPage";
import EncodeDecodePage from "./tools/EncodeDecodePage";
import NotificationPage from "../notification/NotificationPage";
import License from "../license/License";
import BackupPage from "../backupRestore/BackupPage";
import { useDispatch, useSelector } from "react-redux";
import Button from "@atlaskit/button/new";
import { fetchVersionInfo } from "../redux/actions/versionActions";
import CustomerBanner from "../common/components/CustomerBanner";

const NAV_STATE_STORAGE_KEY = "mainNavCollapsed";

const AppFrame = () => {
  const dispatch = useDispatch();
  const flows = useSelector((state) => state.integration.flows);
  const versionInfo = useSelector((state) => state.version);
  const [isNavCollapsed, setIsNavCollapsed] = useState(() => {
    if (typeof window === "undefined") {
      return false;
    }
    return window.sessionStorage.getItem(NAV_STATE_STORAGE_KEY) === "true";
  });

  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }
    window.sessionStorage.setItem(NAV_STATE_STORAGE_KEY, isNavCollapsed ? "true" : "false");
  }, [isNavCollapsed]);

  useEffect(() => {
    dispatch(fetchVersionInfo());
  }, [dispatch]);

  const toggleNavigation = () => {
    setIsNavCollapsed((prev) => !prev);
  };

  const shouldShowUpgradeBanner = versionInfo?.hasLoaded && versionInfo?.isForge === false;

  return (
    <Router>
      <Page navigation={isNavCollapsed ? null : <MainNav onToggleCollapse={toggleNavigation} />}>
        <Grid layout="fluid">
          <GridColumn medium={12}>
            {isNavCollapsed && (
              <div style={{ margin: "8px 0" }}>
                <Button appearance="subtle" onClick={toggleNavigation}>
                  Open navigation
                </Button>
              </div>
            )}
            {shouldShowUpgradeBanner && (
              <div className="ihub-upgrade-banner">
                <strong>Upgrade available.</strong> You are not running the Forge edition. Please upgrade to the latest
                version for the best experience.
              </div>
            )}
            <CustomerBanner />
            <Loading />

            <Routes>
              <Route path="/integration/*" element={<ErrorBoundary><IntegrationsPage /></ErrorBoundary>} />
              <Route path="/credential/:authId?" element={<ErrorBoundary><AuthPage /></ErrorBoundary>} />
              <Route path="/log" element={<ErrorBoundary><ExecutionLogPage isGlobal /></ErrorBoundary>} />
              <Route path="/jsonpath" element={<ErrorBoundary><JsonPathPage /></ErrorBoundary>} />
              <Route path="/encodedecode" element={<ErrorBoundary><EncodeDecodePage /></ErrorBoundary>} />
              <Route path="/notifications" element={<ErrorBoundary><NotificationPage /></ErrorBoundary>} />
              <Route path="/backups" element={<ErrorBoundary><BackupPage /></ErrorBoundary>} />
              <Route path="/license" element={<ErrorBoundary><License /></ErrorBoundary>} />
              <Route path="*" element={<ErrorBoundary>{flows.length > 0 ? <Navigate to="/integration" replace /> : <LandingPage />}</ErrorBoundary>} />
            </Routes>
          </GridColumn>
        </Grid>
      </Page>
    </Router>
  );
};
export default AppFrame;
